<template>
  <div class='pool-party' :class='cssType'>
    <div class="mask" v-if="!store?.state?.cpUserInfo.token" @click="showLoginDialog = true"></div>
    <Banner />
    <AppLang class='app-lang' type='act-pool-party' />
    <div class="main">
      <ValidateUser class="validate-user" ref="validateUserRef" />
      <WelcomReward :isRewardStartTime="isRewardStartTime" />
      <DailyReward />
      <Exchange />
      <AccumReward />
      <!-- <Record /> -->
      <Rule />
      <div class="bottom-bg"></div>
    </div>
    <AppFooter />
    <ActFloat />
    <LoginDialog v-model="showLoginDialog" @submit="handleSubmit" />
    <!-- <CountDown :realTime="state.realTime" class="root-count-down" /> -->
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, provide, computed, reactive } from 'vue'
import { useStore } from 'vuex'
import { isMobile } from '@/utils'
import Banner from './components/Banner'
import AppLang from '@/components/AppLang'
import ValidateUser from '@/components/ValidateUser/ActPoolParty'
import WelcomReward from './components/WelcomReward'
import DailyReward from './components/DailyReward'
import AccumReward from './components/AccumReward'
import Exchange from './components/Exchange'
// import Record from './components/Record'
import Rule from './components/Rule'
import AppFooter from '@/components/AppFooter'
import ActFloat from './components/ActFloat'
import { getDefaultCommonConf, getDefaultUserDetail } from './defaultConf'
import PoolPartyActApi from '@/config/poolPartyActApi'
import LoginDialog from './components/Dialog/LoginDialog/index.vue'
import { useLog } from '@/composables/useLog'
const log = useLog()
log.track('act_pp_page_entry', {
  referrer: document.referrer
})

const cssType = isMobile ? 'mobile' : 'pc'
const store = useStore()

const state = reactive({
  serverTime: 0,
  realTime: 0,
  logTime: 0,
  rewardStartTime: 0
})

const isRewardStartTime = computed(() => {
  return state.realTime >= state.rewardStartTime
})
provide('globalState', state)
const commonConf = ref(getDefaultCommonConf())
provide('commonConf', commonConf)
const getCommonConf = async () => {
  const res = await PoolPartyActApi.getCommonConfig()
  commonConf.value = res
  if (!state.serverTime) {
    state.serverTime = res.serverTime * 1000
    state.realTime = state.serverTime
    state.logTime = Date.now()
    state.rewardStartTime = res.rewardStartTime * 1000
    startSetServerTime()
  }
}

const startSetServerTime = () => {
  setInterval(() => {
    const now = Date.now()
    const diff = now - state.logTime
    state.realTime = state.serverTime + diff
  }, 1000)
}

const userDetail = ref(getDefaultUserDetail())
provide('userDetail', userDetail)
const getUserDetail = async () => {
  if (store.state.cpUserInfo.cpUserId && store.state.cpUserInfo.token) {
    const res = await PoolPartyActApi.getUserDetail()
    userDetail.value = res
  } else {
    userDetail.value = getDefaultUserDetail()
  }
}

const globalConf = computed(() => {
  const getDailyRewardStatus = (dayIndex) => {
    return userDetail.value.dailyRewardStatusList.find(item => item.dayIndex === dayIndex)?.status ?? 0
  }
  const getAccumulateRechargeStatus = (rewardCode) => {
    return userDetail.value.accumulateRewardStatusList.find(item => item.rewardCode === rewardCode)?.status ?? 0
  }
  const conf = JSON.parse(JSON.stringify(commonConf.value))
  conf.isReceivedWelcomeReward = userDetail.value.isReceivedWelcomeReward
  conf.isExchanged = userDetail.value.isExchanged
  conf.canExchange = userDetail.value.canExchange
  conf.activityPropList = userDetail.value.activityPropList
  conf.totalRechargeDiamondCount = userDetail.value.totalRechargeDiamondCount
  conf.dailyRewardConfigList.forEach(item => {
    item.status = getDailyRewardStatus(item.dayIndex)
  })
  conf.accumulateRechargeConfigList.forEach(item => {
    item.status = getAccumulateRechargeStatus(item.rewardCode)
  })
  return conf
})
provide('globalConf', globalConf)
provide('refreshUserDetail', getUserDetail)

const init = async () => {
  getCommonConf()
}

watch(() => store.state.cpUserInfo, () => {
  getUserDetail()
}, {
  immediate: true,
  deep: true
})

init()

onMounted(() => {
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      if (store.state.cpUserInfo.token) {
        getUserDetail()
      }
    }
  }
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // 组件卸载时移除监听器
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })
})


const showLoginDialog = ref(false)
const validateUserRef = ref(null)
const handleSubmit = (userId) => {
  if (validateUserRef.value) {
    validateUserRef.value.setUserId(userId)
    validateUserRef.value.handleActSubmit('poolParty')
  }
}
if (!store.state.cpUserInfo.cpUserId || !store.state.cpUserInfo.token) {
  showLoginDialog.value = true
}
</script>

<style lang='less' scoped src='./pc_style.less'></style>
<style lang='less' scoped src='./mobile_style.less'></style>